module.exports = __webpack_public_path__ + "img/CG-Logo-S.5d4ade52.png";